import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PackageCard from './PackageCard';
import destinationsData from '../data/destinations.json';
import './SearchResults.css';

const DestinationPackages = () => {
  const { destinationName } = useParams();
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [destination, setDestination] = useState(null);

  useEffect(() => {
    // Scroll to top when component loads
    window.scrollTo(0, 0);
    
    setLoading(true);
    
    // Find the destination in our data
    const dest = destinationsData.destinations[destinationName];
    if (dest) {
      setDestination(dest);
      
       // Convert destination packages to SearchResults format
       const convertedPackages = dest.packages.map(pkg => {
         return {
           id: pkg.id,
           title: pkg.title,
           destinations: pkg.itinerary,
           duration: pkg.duration,
           rating: parseFloat(pkg.rating.split(' ')[0]) || 0,
           reviewCount: pkg.rating.split('(')[1] ? pkg.rating.split('(')[1].replace(')', '') : '0',
           originalPrice: parseInt(pkg.originalPrice.replace(/[^\d]/g, '')) || 0,
           discount: parseInt(pkg.savings.replace(/[^\d]/g, '')) || 0,
           finalPrice: parseInt(pkg.finalPrice.replace(/[^\d]/g, '')) || 0,
           images: pkg.images && pkg.images.length > 0 ? pkg.images : [pkg.image || 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop']
         };
       });
      
      setPackages(convertedPackages);
    } else {
      // If destination not found, redirect to search
      navigate('/search');
      return;
    }
    
    setLoading(false);
  }, [destinationName, navigate]);

  if (loading) {
    return (
      <div className="search-results">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading packages...</p>
        </div>
      </div>
    );
  }

  if (!destination) {
    return (
      <div className="search-results">
        <div className="no-results">
          <h2>Destination not found</h2>
          <button onClick={() => navigate('/')} className="btn btn-primary">
            Go Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="search-results">
      <div className="results-header">
          {/* Custom header similar to Dubai search page */}
                <div className="destination-header">
                  <h1 className="destination-title">{destination.name}</h1>
                  {packages.length > 0 && (
                    <div className="destination-price-range">
                      ₹{Math.min(...packages.map(p => p.finalPrice)).toLocaleString('en-IN')} - ₹{Math.max(...packages.map(p => p.finalPrice)).toLocaleString('en-IN')}
                    </div>
                  )}
                  <div className="destination-count">{packages.length} packages found</div>
                </div>
              </div>

      <div className="packages-grid">
        {packages.map(pkg => (
          <PackageCard 
            key={pkg.id}
            title={pkg.title}
            destinations={pkg.destinations}
            duration={pkg.duration}
            rating={pkg.rating}
            reviewCount={pkg.reviewCount}
            originalPrice={pkg.originalPrice}
            discount={pkg.discount}
            finalPrice={pkg.finalPrice}
            images={pkg.images}
            id={pkg.id}
          />
        ))}
      </div>

      {packages.length === 0 && (
        <div className="no-results">
          <h2>No packages found for {destination.name}</h2>
          <button onClick={() => navigate('/')} className="btn btn-primary">
            Go Home
          </button>
        </div>
      )}
    </div>
  );
};

export default DestinationPackages;
